export default {
  routes: [
    {
      name: 'eventlogs',
      path: '/directory/eventlog',
      component: () => import('./views/TheEventLogs.vue'),

    },

    {
      name: 'eventlog',
      path: '/directory/eventlog/:uuid',
      component: () => import('./views/TheEventLog.vue'),
    },
  ]
}
